(function () {
  if (window.__availabilityInfoInit) return;
  window.__availabilityInfoInit = true;

  var openModal = null;
  var lastFocus = null;

  function getModal(trigger) {
    var root = trigger.closest('[data-product-details]') || document;
    return (
      root.querySelector('.availability-info-modal') ||
      document.querySelector('.availability-info-modal')
    );
  }

  function setCurrentKind(modal, kind) {
    modal.querySelectorAll('[data-availability-kind]').forEach(function (item) {
      item.classList.toggle('is-current', kind !== '' && item.getAttribute('data-availability-kind') === kind);
    });
  }

  function focusables(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      return !el.hasAttribute('disabled') && el.offsetParent !== null;
    });
  }

  function scrollbarGap() {
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  }

  function lockPageScroll() {
    document.documentElement.style.setProperty(
      '--availability-scrollbar-gap',
      scrollbarGap() + 'px'
    );
    document.body.classList.add('availability-info-modal-open');
  }

  function unlockPageScroll() {
    document.body.classList.remove('availability-info-modal-open');
    document.documentElement.style.removeProperty('--availability-scrollbar-gap');
  }

  function open(trigger) {
    var modal = getModal(trigger);
    if (!modal) return;

    lastFocus = document.activeElement;
    openModal = modal;
    openModal._availabilityTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    setCurrentKind(modal, trigger.getAttribute('data-availability-kind') || '');
    lockPageScroll();
    modal.hidden = false;

    var dialog = modal.querySelector('.availability-info-modal__dialog');
    if (dialog) dialog.focus();
  }

  function close() {
    if (!openModal) return;

    var trigger = openModal._availabilityTrigger;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    openModal.hidden = true;
    openModal.querySelectorAll('.is-current').forEach(function (item) {
      item.classList.remove('is-current');
    });
    unlockPageScroll();

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }

    openModal = null;
    lastFocus = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-availability-info-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    if (openModal && event.target.closest('[data-availability-info-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    var nodes = focusables(openModal);
    if (nodes.length === 0) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
